// extracted by mini-css-extract-plugin
export default {"pagination":"index_pagination__ps3rY","tHeader":"index_tHeader__jo9lY","tBodys":"index_tBodys__oCK7w","divideLine":"index_divideLine__EpqDY","noData":"index_noData__Koq5i"};